export const GET_SERVICE_APPLICATION = gql`
    query retrieveMerchantServiceApplication($merchantAccountNumber: String!) {
        retrieveMerchantServiceApplication(merchantAccountNumber: $merchantAccountNumber) {
            id
            status
            businessInformation
            merchantInformation
            partnerId
            serviceRequirements
            outletInformation
            supportingDocuments
            terminalId
            authorId
            mid
            isServiceApplication
            worldpayPO
            merchantAccountNumber
            partner {
                firstName
                lastName
                business {
                    legalName
                }
            }
            adobeSignJobs {
                jobId
                principalSignatureIndex
            }
        }
    }
`;
